const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_GRKlTYjgb",
    "aws_cognito_identity_pool_id": "eu-west-1:041b1b3c-c6a0-4c56-8d4d-002a45c5a57b",
    "aws_user_pools_web_client_id": "5vjrqisbqg6edpfff4t1hlk3nr",
    "aws_cloud_logic_custom": [
        {
            "name": "stripe",
            "endpoint": "https://94tpz80bzk.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ]
};

export default awsmobile;